import { render, staticRenderFns } from "./CompraDiretaVisualizacaoDadosGerais.vue?vue&type=template&id=6980cbac&scoped=true"
import script from "./CompraDiretaVisualizacaoDadosGerais.vue?vue&type=script&lang=js"
export * from "./CompraDiretaVisualizacaoDadosGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980cbac",
  null
  
)

export default component.exports